import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addAlert } from "src/modules/notification/redux";
import CompanyExpiredDateDialogComponent from "./company-expired-date-dialog.component";
import companiesApi from "../../../../../configs/apis/companies";

export default function CompanyExpiredDateDialogContainer({
  industries,
  selectedCompany,
  onCompanyDialogCloseClick,
  onEditDateClick,
}) {
  const dispatch = useDispatch();
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    if (selectedCompany) {
      setLoading(true);
      companiesApi
        .getCompanyExpiredDate(selectedCompany.company.id)
        .then((response) => {
          if (response.success) {
            setCompanyData({
              ...selectedCompany,
              company: {
                ...selectedCompany.company,
                expired_at: response.data.expired_at,
                deactive_at: response.data.deactive_at,
              },
            });
          } else {
            dispatch(
              addAlert({
                severity: "error",
                message:
                  response.message || "Failed to fetch company expiration data",
              })
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching company expiration data:", error);
          dispatch(
            addAlert({
              severity: "error",
              message: "Error fetching company expiration data",
            })
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [selectedCompany, dispatch]);

  const handleEditDate = ({ id, expiredAt, plan }) => {
    setUpdating(true);
    companiesApi
      .updateCompanyExpiredDate({
        id,
        expiredAt,
      })
      .then((response) => {
        if (response.success) {
          dispatch(
            addAlert({
              severity: "success",
              message: "Company expiration date updated successfully",
            })
          );
          onCompanyDialogCloseClick();
          setCompanyData((prevData) => ({
            ...prevData,
            company: {
              ...prevData.company,
              expired_at: expiredAt,
              plan,
            },
          }));
          if (onEditDateClick) {
            onEditDateClick(response.data); // Parent should refetch data here
          }
        } else {
          dispatch(
            addAlert({
              severity: "error",
              message:
                response.message || "Failed to update company expiration date",
            })
          );
        }
      })
      .catch((error) => {
        console.error("Error updating company expiration date:", error);
        dispatch(
          addAlert({
            severity: "error",
            message: "Error updating company expiration date",
          })
        );
      })
      .finally(() => {
        setUpdating(false);
      });
  };

  return (
    <CompanyExpiredDateDialogComponent
      industries={industries}
      selectedCompany={companyData || selectedCompany}
      onCompanyDialogCloseClick={onCompanyDialogCloseClick}
      onEditDateClick={handleEditDate}
      loading={loading || updating}
    />
  );
}
